<template>
  <div class="default-table">
    <el-table
      :data="dataList"
      row-key="id"
      v-show="mod === 'Table'"
      @selection-change="handleSelectionChange"
      @row-contextmenu="openMenu"
      :ref="tableRef"
      @sort-change="changeTableSort"
      highlight-current-row border>

      <el-table-column :reserve-selection="true" type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
      <el-table-column label="最后更新" prop="updated_at" width="135" align="center" sortable="custom">
        <template v-slot="{ row: { updated_at } }">
          <span>{{ updated_at | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品名称" prop="title" width="160" show-overflow-tooltip align="center">
        <template slot-scope="{row}">
          <span>{{ row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="产品图" prop="cover" width="70" align="center">
        <template slot-scope="{row}">
          <product-image style="width: 40px;height: 40px" :image-url="row.cover_url" />
        </template>
      </el-table-column>
      <el-table-column label="秒杀品" width="70" align="center">
        <template v-slot="{ row: { is_sec_kill } }">
          {{ is_sec_kill === 'Y' ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="类目" prop="category_id" min-width="120" align="center" sortable="custom">
        <template slot-scope="{row}">
          <span>{{ row.category || '' }}</span>
        </template>
      </el-table-column>

      <!-- 可播平台列 - 根据showPlatform控制显示 -->
      <el-table-column v-if="showPlatform" label="可播平台" prop="platform_name" min-width="120" align="center">
        <template slot-scope="{row}">
          <span>{{ String(row.platform_names) || '' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="规格" prop="spec_name" align="center" min-width="100"></el-table-column>
      <el-table-column label="季节性" prop="used_season" align="center" min-width="100"></el-table-column>
      <el-table-column label="品牌" prop="brand_name" align="center" min-width="100"></el-table-column>
      <el-table-column align="center" label="色号/香型" min-width="100" prop="spec_color"></el-table-column>
      <el-table-column label="合作方式" prop="mode" header-align="center" align="center" min-width="110"
                       sortable="custom">
        <template slot-scope="{row}">
          <span>{{ row.mode_alias || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="日常价(元)" align="center" min-width="100">
        <template slot-scope="{row}">
          <span>{{ row.price || '/' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="直播价(元)" align="center" min-width="100">
        <template slot-scope="{row}">
          <span>{{ row.lb_price || '/' }} </span>
        </template>
      </el-table-column>
      <el-table-column label="赠品" prop="gift" align="center" min-width="140" show-overflow-tooltip>
        <template slot-scope="{row}">
          <span>{{ row.gift || '/' }} </span>
        </template>
      </el-table-column>
      <el-table-column label="独家机制" prop="other_activity" align="center" min-width="120"
                       show-overflow-tooltip>
        <template slot-scope="{row}">
          <span>{{ row.other_activity || '' }} </span>
        </template>
      </el-table-column>
      <el-table-column label="坑位费(元)" prop="ad_space_fee" align="center" min-width="120" sortable="custom">
        <template slot-scope="{row}">
          <span>{{ row.ad_space_fee || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="线上佣金(%)" prop="online_cmn" align="center" min-width="120" sortable="custom">
        <template slot-scope="{row}">
          <span class="rate">{{ row.online_cmn || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="线下佣金(%)" prop="offline_cmn" align="center" min-width="120" sortable="custom">
        <template slot-scope="{row}">
          <span class="rate">{{ row.offline_cmn || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="负责人" prop="leader_id" align="center" min-width="100" sortable="custom">
        <template slot-scope="{row}">
          <span>{{ row.leader_name || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注信息" prop="remark" align="center" min-width="140" show-overflow-tooltip>
        <template slot-scope="{row}">
          <span>{{ row.remark || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="店铺名称" prop="company_name" align="center" min-width="100">
        <template slot-scope="{row}">
          <span>{{ row.company_name || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="店铺注册公司" show-overflow-tooltip prop="mini_customer_name" width="160"
                       align="center">
      </el-table-column>
      <el-table-column label="产品链接" prop="product_url" align="center" min-width="120">
        <template slot-scope="{row}">
          <el-link type="primary" underline :href="row.product_url" target="_blank">点击查看</el-link>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="created_at" min-width="140" align="center">
        <template slot-scope="{row}">
          <span :title="`修改时间：${row.updated_at}`">{{ row.created_at || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="130" fixed="right">
        <template slot-scope="{row}" >
          <div style='display: flex;justify-content: space-evenly'>
            <el-link type="primary" icon="el-icon-edit" @click="handleEdit(row)"
                     v-if="userPermissions.indexOf('product_edit') > -1">修改
            </el-link>
            <el-link type="danger" icon="el-icon-delete" @click="handleDelete(row)"
                     v-if="(userPermissions.indexOf('product_delete') > -1 && userInfo.id === row.leader_id) || userPermissions.indexOf('product_delete_all') > -1">
              删除
            </el-link>
          </div>

        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ProductImage from '@/pages/lb/product/ProductImage'
import { mapGetters } from 'vuex'

export default {
  name: 'LbProductComponentsProductTable',
  components: {
    ProductImage
  },
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    mod: {
      type: String,
      default: 'Table'
    },
    showPlatform: {
      type: Boolean,
      default: true
    },
    tableRef: {
      type: String,
      default: 'multipleTable'
    }
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo'])
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit('selection-change', val)
    },

    openMenu(row, column, e) {
      this.$emit('row-contextmenu', { row, column, e })
    },

    changeTableSort(sortInfo) {
      this.$emit('sort-change', sortInfo)
    },

    handleEdit(row) {
      this.$emit('edit', row)
    },

    handleDelete(row) {
      this.$emit('delete', row)
    },

    clearSelection() {
      // 清除表格中所有选中的行
      const table = this.$refs[this.tableRef]
      if (table && table.clearSelection) {
        table.clearSelection()
      }
    }
  }
}
</script>

<style scoped>
.default-table {
  /* 保持原有的表格样式 */
}
</style>
